export { default } from './LandingPageCta'
